import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { GTCRequisitionservice } from 'src/app/Shared/GTCRequisition.service';
import { CommonService } from 'src/app/Shared/common.service';
import { AddClauseComponent } from '../add-clause/add-clause.component';
import { MatTable } from '@angular/material/table';

interface Filter {
  name: string;
  code: string;
}
@Component({
  selector: 'app-special-approval',
  templateUrl: './special-approval.component.html',
  styleUrls: ['./special-approval.component.css']
})
export class SpecialApprovalComponent implements OnInit {
  requestId: any;
  GTCNo: any;
  IsFilterShown:any;
  formGroup: any ;
  IsFormEditableForTQL: any;
  FormStatusName: any;
  values: Filter[] | undefined;
  ClauseDetailsList: any;
  SelectedAction: any;
  IsLoadingResults: any;
  ReturnByTQLLeader = 9;  //13. Incorrect Status Update and Unauthorized Save as Draft Option for TQ Leader
  Draft = 1;
  PendingWithTQTeam = 2;
  RecordStatus: any;
  Reason: any;
  TQLeaderRequistion!: FormGroup;
  ClauseViewList: Array<{
    GtcID: number;
    ClauseNo: string,
    PaceID: string,
    EntityName: string,
    IsActive: boolean,
    CreatedOn: string,
    ClauseDetailsList: Array<any>
  }> = [];
  displayedColumns: string[] =
    ['ClauseNo', 'PaceID', 'EntityName', 'CreatedOn'];
  @ViewChild(MatTable, { static: false }) table!: MatTable<any>
  constructor(private http: HttpClient,
    private fb: FormBuilder,
    private _router: Router,
    private activatedRoute: ActivatedRoute,
    public _global: GlobalVariables,
    private _gtcService: GTCRequisitionservice,
    private _commonService: CommonService,
    private _dialog: MatDialog) {
    this.TQLeaderRequistion = this.fb.group({
      GTCID: [],
      RequestEntityId: [''],
      RecordStatus: [],
      FirmId: [],
      FirmName: [''],
      EngPartnerName: [''],
      PaceID: [''],
      IsIndependenceRestrictedClient: [],
      BusinessCaseAcceptanceReason: [''],
      ScopeOfWorkInBrief: [],
      RiskProfileEngagement: [],
      ExpectedFeesFromClient: [],
      ClauseViewList: [],
      Remarks:[''],
      ActionTakenByTQL: [''],
      ClientID: [''],
      EngPartnerGPN: [''],
      ClientName: [''],
      SendToTQLWithReasons: [''],
      PushBackDone: ['']
    });
  }
  ngOnInit(): void {

    this.values = [
      { name: 'Modified', code: 'M' },
      { name: 'Drop', code: 'D' },
      { name: 'Add SubClause', code: 'S' },
      { name: 'No Change', code: 'N' },
  ];
  this.IsFilterShown= false;
  this.formGroup = new FormGroup({
      selectedCity: new FormControl<Filter | null>(null)
  });

    this.requestId = this.activatedRoute.snapshot.paramMap.get('ReqId');
    this.ClauseDetailsList = [];
    if (!this.checkValueIsNullOrEmptyOrUndefined(this.requestId)) {
      this._global.auditTrailId = this.requestId;
      this._global.auditTrailClass = 'TQLClass';
      this.TQLeaderRequistion.controls['RequestEntityId'].setValue(this.requestId);
      this.GetGTCRequestById(this.requestId);
    }
  }
  SendToTQOrET(templateRef: any, actionId: any) {
    this.SelectedAction = actionId;
    const dialogreturnRejectRequest = this._dialog.open(templateRef, {
      width: '750px',
      disableClose: true
      // data: { name: this.name, animal: this.animal }
    });
  }


  onFilterchange(event:any){

    var value = event.value.name;
    if(!this.checkValueIsNullOrEmptyOrUndefined(value)){
      if(value=='Modified'){ //1

       this.ClauseViewList.sort((s:any)=>{

          const name1 = s.ClauseDetailsList;
          if(name1.ClauseRadioType == '1'){
            return -1;
          }
          else{
            return 1
          }
        });
      
      }
      else if(value=='Add SubClause')//4
      {
       this.ClauseViewList.sort((s:any)=>{

          const name1 = s.ClauseDetailsList;
          if(name1.ClauseRadioType == '4'){
            return -1;
          }
          else{
            return 1
          }
        });

      }
      else if(value=='No Change')//3
      {
        this.ClauseViewList.sort((s:any)=>{

          const name1 = s.ClauseDetailsList;
          if(name1.ClauseRadioType == '3'){
            return -1;
          }
          else{
            return 1
          }
        });

      }
      else if(value=='Drop')//2
      {
      this.ClauseViewList.sort((s:any)=>{

        const name1 = s.ClauseDetailsList;
          if(name1.ClauseRadioType == '2'){
            return -1;
          }
          else{
            return 1
          }
        });

      }
    }
  }
  SendBack(SelectedAction: any) {
    this.IsLoadingResults = true;

    var message = '';
    //13. Incorrect Status Update and Unauthorized Save as Draft Option for TQ Leader
    if (SelectedAction === this.ReturnByTQLLeader) {
      this.RecordStatus = this.ReturnByTQLLeader;
      message = 'Are you sure you want to send the request to Engagement Team?';
    }
    //13. Incorrect Status Update and Unauthorized Save as Draft Option for TQ Leader
    else if (SelectedAction === this.PendingWithTQTeam) {
      this.RecordStatus = 2
      message = 'Are you sure you want to send the request to TQ Team?';
    }
    //13. Incorrect Status Update and Unauthorized Save as Draft Option for TQ Leader
    if (
      (SelectedAction === this.PendingWithTQTeam || SelectedAction === this.ReturnByTQLLeader)
      && (this.Reason == null || this.Reason == undefined || this.Reason.replace(/\s/g, "") == "")) {
    this.IsLoadingResults = false;

      alert('Please enter Reason');
      return;
    }
    //13. Incorrect Status Update and Unauthorized Save as Draft Option for TQ Leader
    if (!confirm(message)) { return; }
    this._dialog.closeAll();
    this.getFormControls('RecordStatus').setValue(this.RecordStatus);
    this.getFormControls('Remarks').setValue(this.Reason);
    this.getFormControls('ActionTakenByTQL').setValue(this.Reason);

    this._gtcService.sendBackToTQOrET(this.TQLeaderRequistion.value).subscribe((data: any) => {
    this.IsLoadingResults = false;

      alert(data.RequestMessage);
      if (data.RequestIsSuccess) {
        window.history.back();
        //this.GetGTCRequestById(this.RequestEntityId);
      }
    },(error:any)=>{
      this.IsLoadingResults = false;

    });
  }
  Cancel() {
    this._dialog.closeAll();
  }
  GetGTCRequestById(requestId: any) {
    this.IsLoadingResults = true;
    if (!this.checkValueIsNullOrEmptyOrUndefined(requestId)) {
      this._gtcService.GetGTCRequestByIdForTQLeader(requestId).subscribe(data => {
        // this.GTCForm.patchValue(data);
        if(!this.checkValueIsNullOrEmptyOrUndefined(data)){
          this.IsLoadingResults = false;
          this.TQLeaderRequistion.patchValue({
            RecordStatus: data.recordStatus,
            FirmId: data.FirmID != null ? String(data.FirmID) : data.FirmID,
            FirmName: data.EntityName,
            EngPartnerName: data.EngPartnerName,
            ClientName: data.ClientName,
            PaceID: data.PACEID,
            IsIndependenceRestrictedClient: data.IsIndependenceRestrictedClient != null ? String(data.IsIndependenceRestrictedClient) : data.IsIndependenceRestrictedClient,
            BusinessCaseAcceptanceReason: data.BusinessCaseAcceptanceReason,
            ScopeOfWorkInBrief: data.ScopeOfWorkInBrief,
            RiskProfileEngagement: data.RiskProfileEngagement != null ? String(data.RiskProfileEngagement) : data.RiskProfileEngagement,
            ExpectedFeesFromClient: data.ExpectedFeesFromClient,
            ClauseViewList: data.ClauseViewList,
            ClientID: data.ClientID,
            EngPartnerGPN: data.EngPartnerGPN,
            SendToTQLWithReasons: data.SendToTQLWithReasons,
            PushBackDone: data.PushBackDone
          });
          this.ClauseViewList = this.getFormControls('ClauseViewList').value;
          this.FormStatusName = data.StatusName;
          this.GTCNo = data.GTCNumber;
          this.IsFormEditableForTQL = data.IsSendToTQLeader;
          // this.paceList = {ENGCode: data.PACEID};
          var count = 0;
          this.ClauseViewList.map((todo, i) => {
            count = count + 1
            this.ClauseViewList[i].PaceID = this.getFormControls('PaceID').value;
            this.ClauseViewList[i].EntityName = this.getFormControls('FirmName').value;
            this.ClauseViewList[i].GtcID = count
          });
        }
        else{
          this.IsLoadingResults = false;

      alert('Something is Wrong with the data');
      window.history.back();
          
        }

   
      });
    }

  }
  getFormControls(controlName: any) {
    return this.TQLeaderRequistion.controls[controlName];
  }


  onSubmit() {
  }
  Exit() {
    this._router.navigate(['/home']);
  }
  ResetData() {
  }
  SendToET() {
  }
  SendToTQ() {
  }
  GetResult() {
  }
  checkValueIsNullOrEmptyOrUndefined(value: any) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
    else {
      return false;
    }
  }
}
